import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import TextField from 'material-ui/TextField';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import IconButton from 'material-ui/IconButton';
import { GetApp } from 'material-ui-icons'
import moment from 'moment'
import Button from 'material-ui/Button';
import jsPDF from 'jsPDF'
import html2canvas from 'html2canvas'
import htmlDocx from 'html-docx-js/dist/html-docx';

import { filter } from 'lodash'

import DataTable from './datatable'

import ContainerHeader from '../../../components/ContainerHeader/index';
import * as archiveDetails from '../../../actions/archivedetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as filedownload from '../../../actions/fileupload';


class ExportHTML extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        const { data } = this.props
        if (data && data[0])
            this.props.generateDocPDF(data[0].meetingNumber)
    }
    render() {
        const { data } = this.props;
        return (
            // https://wordtohtml.net/
            <div className="hidden1" style={{ height: 0, opacity: 0 }}>
                <div id="divToPrint" >
                    {data && <div id="divSet" className="flex-auto" style={{ width: '90%', fontSize: '18pt', }}>
                        <h1 style={{ textAlign: 'center' }}>Meeting Agenda - {data[0].meetingName}</h1>
                        <table className="blueTable" style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '40%' }}>Meeting Name:</td>
                                    <td style={{ width: '50%' }}>{data[0].meetingName}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '40%' }}>Meeting Number:</td>
                                    <td style={{ width: '50%' }}>{data[0].meetingNumber}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <h2>Agenda Details</h2>
                            <table className="blueTable" style={{ width: '100%' }} border="1">
                                <thead>
                                    <tr style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
                                        <th style={{ width: '3%' }}>#</th>
                                        <th style={{ width: '28%' }}>Item</th>
                                        <th style={{ width: '28%' }}>Headed By</th>
                                        <th style={{ width: '28%' }}>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((_data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{_data.name}</td>
                                                <td>{_data.headedBy}</td>
                                                <td>{_data.notes}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    }
                </div>
            </div>
        );
    }
}

class AgendaList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            setValue: false,
            committee_id: Number(this.props.loginUser.data.committee_id),
            smeetingId: Number(this.props.params.smeetingId ? this.props.params.smeetingId : 0),
            agendaitemList: null,
            agendaitemmeetingDetails: null,
            mmdata: null,
        }
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.setState({ setValue: false, agendaitemList: null, agendaitemmeetingDetails: null })
        this.props.actions.getAgendaItemDetailsList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    handleChangeAgendaItem(e) {
        this.filterAgendaList(e.target.value)
    }

    filterAgendaList(smeetingId) {
        // console.log('smeetingId',smeetingId)
        if (smeetingId > 0) {
            this.setState({ smeetingId: Number(smeetingId) })
            let list = filter(this.props.getDataList.archivedetailsList, ['smeetingId', smeetingId])
            // console.log(list)
            this.setState({ agendaitemmeetingDetails: list.length > 0 ? list[0] : null })

            this.props.actions.getArchiveAgendaDetailsList(smeetingId)
            // list = list.length > 0 ? list[0].agendaList : []
            // this.setState({ agendaitemList: list, })
        }
    }

    handleFilterText() {
        this.setState({ filterText: this.refs.filterTextInput.value ? this.refs.filterTextInput.value.toLowerCase() : undefined });
    };

    downloadNotes(sMeeting) {
        if (sMeeting && sMeeting.meetingMinutesFiles) {
            var files = sMeeting.meetingMinutesFiles;

            if (files && files.length > 0) {



                console.log('file id ', files);

                this.props.actions.fileDownloadArchivedMeetingMinutesFile(files[0])
            }
            // this.setState({ mmdata: this.props.getDataList.archivedetails })

        }


    }

    generateDocPDF(fileName) {
        this.setState({ mmdata: null, downloaded: false });
        // $(input).attr('style', "backgroundColor: 'red';width: '210mm';minHeight: '297mm';marginLeft: 'auto';marginRight: 'auto'")
        const input = '<!DOCTYPE html><html><body>' + document.getElementById('divToPrint').outerHTML + '</body></html>';
        var converted = htmlDocx.asBlob(input);
        // htmlDocx.saveAs(converted, 'test.docx');
        const url = window.URL.createObjectURL(new Blob([converted], { type: 'application/docx' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '_AgendaNotes.docx');
        document.body.appendChild(link);
        link.click();
        // this.props.setInProgress(false);

        // const pdfinput = document.getElementById('divToPrint')
        // // https://github.com/MrRio/jsPDF
        // html2canvas(pdfinput)
        //     .then((canvas, _this = this) => {
        //         document.body.appendChild(canvas);
        //         const imgData = canvas.toDataURL('image/png');
        //         // console.log(pdfinput)
        //         const pdf = new jsPDF('portrait', 'pt', 'a4');
        //         const pdfConf = {
        //             margin: 1,
        //             pagesplit: false,
        //             background: '#fff'
        //         };
        //         _this.state.mmdata = null;
        //         pdf.addHTML(canvas, 20, 20, pdfConf, () => {
        //             document.body.removeChild(canvas);
        //             // pdf.addPage();
        //             pdf.save('download.pdf');
        //         });
        //         this.props.setInProgress(false);
        //     });

    }

    componentDidMount() {
        // console.log('props', this.props)
        this.setState({ setValue: false, })
        this.props.actions.loadswitchercommittees();
        if (this.state.committee_id > 0)
            this.props.actions.getArchiveDetailsList(this.state.committee_id);
    }

    render() {
        const { getDataList, teamDetails, match } = this.props;
        const { agendaitemList, agendaitemmeetingDetails } = this.state;

        console.log('agenta meeting details ', agendaitemmeetingDetails)

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('agendaitemList', agendaitemList);
        if (getDataList && getDataList.Status) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }

       

        if (getDataList && getDataList.archivedetailsList && getDataList.archivedetailsList.length > 0 && !this.state.setValue) {
            this.state.smeetingId = Number(this.props.params.smeetingId ? this.props.params.smeetingId : getDataList.archivedetailsList[0].smeetingId)
            this.setState({ setValue: true })
            this.filterAgendaList(this.state.smeetingId)
        }
        let _agendaitemList = null
        // console.log('getDataList.archivedetailsList', getDataList.archivedetailsList)
        if (getDataList && getDataList.archivedetailsList && getDataList.archivedetailsList.length > 0) {
            _agendaitemList = getDataList.archivedetailsList.map(item => (
                <MenuItem key={item.smeetingId} value={item.smeetingId}
                    style={{ fontWeight: '500' }}>
                    {item.meetingName}
                </MenuItem>
            ))
        }

        let _TeamList = null
        // console.log('AddRole TeamList', roleList)
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }

        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="AgendaItem List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">

                        <Card className="mb-0">
                            <CardHeader className="bg-white p-0">
                                <div className="row p-2">
                                    <div className="col-3 pt-2 pl-4">
                                        <FormControl className="w-100 mb-2 col-12">
                                            <InputLabel htmlFor="age-simple">Team Switcher</InputLabel>
                                            <Select
                                                value={this.state.committee_id}
                                                onChange={this.handleChangeTeam.bind(this)}
                                                input={<Input id="age-simple" />}
                                            >
                                                {_TeamList}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row p-2">
                                    <div className="col-3 pt-2 pl-4">
                                        <FormControl className="w-100 mb-2 col-12">
                                            <InputLabel htmlFor="age-simple">Meeting Switcher</InputLabel>
                                            <Select
                                                value={this.state.smeetingId}
                                                onChange={this.handleChangeAgendaItem.bind(this)}
                                                input={<Input id="age-simple" />}
                                            >
                                                {_agendaitemList}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-3 pl-4">
                                        <TextField margin="normal" className="mt-0 mb-4 col-md-12"
                                            name="description" label="Meeting Number"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.meetingNumber : ''} />
                                    </div>
                                    {/* <div className="col-2 pl-4">
                                        <TextField margin="normal" className="mt-0 mb-4 col-md-12"
                                            name="description" label="Status"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.meeting_status : ''} />
                                    </div> */}
                                    <div className="col-3 pl-4">
                                        <TextField margin="normal" className="mt-0 mb-4 col-md-12"
                                            name="description" label="Date"
                                            value={agendaitemmeetingDetails ? moment(agendaitemmeetingDetails.m_Date).format('DD/MM/YYYY') : ''} />
                                    </div>
                                    <div className="col-3 pt-2 pl-4">
                                        <InputLabel>Meeting Minutes</InputLabel>
                                        <IconButton className="bg-primary ml-1" aria-label="Download" onClick={this.downloadNotes.bind(this, agendaitemmeetingDetails)}>
                                            {/* <i className="zmdi zmdi-collection-pdf"></i> */}
                                            <GetApp />
                                        </IconButton>
                                    </div>
                                </div>
                            </CardHeader>
                        </Card>
                        <div className="mt-2 row">
                            <div className="col-12">
                            <br/>
                                <Card className="mb-0">
                                    <CardHeader className="bg-white p-0">
                                        <div className={`search-bar right-side-icon bg-transparent `}>
                                            <div className="form-group">
                                                <input className="form-control border-1" type="search" placeholder="Search" onChange={this.handleFilterText.bind(this)}
                                                    ref="filterTextInput" value={this.state.filterText} />
                                                <button className="search-icon"><i className="zmdi zmdi-search zmdi-hc-lg" /></button>
                                            </div>
                                        </div>
                                    </CardHeader>
                                </Card>
                                <br/>
                                <DataTable data={getDataList && getDataList.archivedetails && getDataList.archivedetails.length > 0 ? getDataList.archivedetails : null}
                                    filterText={this.state.filterText} />
                            </div>
                        </div>
                    </div>
                </div>
                <ExportHTML data={this.state.mmdata} generateDocPDF={this.generateDocPDF.bind(this)} />
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { loginUser, archiveDetails, teamDetails } = state
    const { match } = ownProps
    return { loginUser, getDataList: archiveDetails, teamDetails, params: ownProps.match.params, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, filedownload, archiveDetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AgendaList);



// WEBPACK FOOTER //
// ./app/archivedetails/agendalist/index.js